import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=57d856e6&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style0 from "./banner.vue?vue&type=style&index=0&id=57d856e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d856e6",
  null
  
)

export default component.exports